import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'placeholder-key';

// Only warn in development, don't throw error
if ((!supabaseUrl || !supabaseAnonKey || supabaseUrl === 'https://placeholder.supabase.co') && import.meta.env.DEV) {
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database types
export interface Profile {
  id: string;
  roll_no: string;
  name: string;
  email: string;
  department: string;
  profile_picture: string | null;
  points: number;
  rank: string;
  streak: number;
  login_streak: number;
  total_activities: number;
  before_after_count: number;
  video_count: number;
  last_activity_date: string | null;
  last_login_date: string | null;
  created_at: string;
  updated_at: string;
}

export interface Achievement {
  id: string;
  profile_id: string;
  achievement_id: string;
  unlocked_at: string;
}

export interface Activity {
  id: string;
  profile_id: string;
  type: 'before-after' | 'video';
  location: string;
  description: string;
  before_image?: string;
  after_image?: string;
  video_url?: string;
  points_earned: number;
  created_at: string;
  session_id?: string;
  caption?: string;
  is_private?: boolean;
}

export interface Reaction {
  id: string;
  activity_id: string;
  profile_id: string;
  type: 'love' | 'fire' | 'star' | 'clap';
  created_at: string;
}

export interface Comment {
  id: string;
  activity_id: string;
  profile_id: string;
  content: string;
  created_at: string;
}